import React, { PropsWithChildren } from 'react';
import classNames from 'classnames';
import { noop } from 'lodash';
import { IconButton } from '../../buttons/icon-button/IconButton';
import { Icon } from '../../icons/Icon';
import styles from './WindowHeader.module.scss';

export const WindowHeader = ({ children, previous, onClose, className, hidePrevious = false }: Props) => {

    const previousClasses = classNames(styles.button, styles.previous, {
        [styles.hide]: !previous,
        [styles.none]: !previous && !onClose
    });

    const closeClasses = classNames(styles.close, {
        [styles.hide]: !onClose,
        [styles.none]: !previous && !onClose
    });

    return (
        <div className={classNames(styles.container, className)}>
            {hidePrevious ? null : (
                <IconButton
                    small onClick={previous ?? noop}
                    className={previousClasses}>
                    <Icon type='general-ui-chevron-left' strokeWidth={2} size='small' />
                </IconButton>
            )}
            <h2 className={styles.heading}>
                {children}
            </h2>

            <IconButton small
                onClick={onClose ?? noop}
                className={closeClasses}>
                <Icon type='general-ui-close' strokeWidth={2} size='small' />
            </IconButton>
        </div>
    );
};

type Props = PropsWithChildren<{
    className?: string;
    previous?: () => void;
    onClose?: () => void;
    hidePrevious?: boolean;
}>;